import type { Permission } from '@/types/permission';
import { db } from '../db';

export const setUserPermissions = async (
  userId: string,
  permissions: string[],
) => {
  db.permissions.put({ id: userId, apiPermissions: permissions }, userId);
};

const hasPermission = async (userId: string, permission: string) => {
  const userPermissions = await db.permissions.get(userId);
  return !!userPermissions?.apiPermissions?.includes(permission);
};

export const hasAnyPermission = async (
  userId: string,
  permissions: Permission[],
) => {
  if (permissions.length === 0) {
    return true;
  }

  for (const permission of permissions) {
    if (await hasPermission(userId, permission)) {
      return true;
    }
  }
  return false;
};

export const hasPermissions = async (
  userId: string,
  permissions: Permission[],
) => {
  for (const permission of permissions) {
    if (!(await hasPermission(userId, permission))) {
      return false;
    }
  }
  return true;
};
